import {
  getDecodedNetworkId,
  getDecodedUserId,
  getTelemetryClientConfig,
  getTelemetryHostingConfig,
} from '@ms/yammer-telemetry-store';

import type { ApplicationContextInput } from '../events';

const notConfigured = '<not configured>';

type GetApplicationContextInput = () => ApplicationContextInput;
export const getApplicationContextInput: GetApplicationContextInput = () => {
  const userId = getDecodedUserId();
  const networkId = getDecodedNetworkId();
  const clientConfig = getTelemetryClientConfig();
  const hostingConfig = getTelemetryHostingConfig();

  const identity = {
    ...(userId && { UserId: userId }),
    ...(networkId && { NetworkId: networkId }),
  };

  if (!clientConfig || !hostingConfig) {
    return {
      ClientId: notConfigured,
      first_party_client: notConfigured,
      client_load_id: notConfigured,
      client_load_time: notConfigured,
      yamjs_revision: notConfigured,
      environment: notConfigured,
      ...identity,
    };
  }

  const { yammerAppClientId, telemetryClientId, appInstanceId, loadedAt, gitRevision } = clientConfig;

  return {
    ClientId: yammerAppClientId,
    first_party_client: telemetryClientId,
    client_load_id: appInstanceId,
    client_load_time: loadedAt.toString(),
    yamjs_revision: gitRevision,
    environment: hostingConfig.hostingEnvironment,
    ...identity,
  };
};
